import api from "./api";

class StarrableManager {

    toggleStar(id: number | string, model: string) {
        return api.post(`/starrable/toggle_star/`, {id, model})
    }
}

export const starrableManager = new StarrableManager()

